import { useEffect, useState } from "react";

type PublicKeyCredential = {
  // tsc does not understand isConditionalMediationAvailable exists :/
  isConditionalMediationAvailable?: () => Promise<boolean>;
} & typeof window.PublicKeyCredential;

export const useIsPasskeySupported = (): boolean => {
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    const passkeySupported = async (): Promise<void> => {
      const pubKeyCred: PublicKeyCredential | undefined =
        window.PublicKeyCredential;
      if (
        pubKeyCred &&
        // typeof check is used as browsers that do not support mediation will not have the 'isConditionalMediationAvailable' method available
        typeof pubKeyCred.isConditionalMediationAvailable === "function"
      ) {
        try {
          const results = await Promise.all([
            pubKeyCred.isUserVerifyingPlatformAuthenticatorAvailable(),
            pubKeyCred.isConditionalMediationAvailable(),
          ]);
          const isSupported = results.every((r) => r === true);
          setSupported(isSupported);
        } catch {
          setSupported(false);
        }
      } else {
        setSupported(false);
      }
    };
    passkeySupported();
  }, []);

  return supported;
};
